<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-freeze-top-row`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.222 4h35.556C43.005 4 44 4.995 44 6.222v35.556A2.222 2.222 0 0141.778 44H6.222A2.222 2.222 0 014 41.778V6.222C4 4.995 4.995 4 6.222 4zM8 21v19h32V21H8zm8.556-4h4.758l9-9h-4.758l-9 9zm13.758 0h-4.758l9-9h4.758l-9 9zm4.242 0H40v-5.444L34.556 17zm-22.242 0l9-9h-4.758L8 16.556V17h4.314zM8 8h4.314L8 12.314V8z"/></svg>
</template>
<script>

export default {
  name: 'IconFreezeTopRow',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
